import { render, staticRenderFns } from "./DocumentReceivingSettings.vue?vue&type=template&id=34408b72"
import script from "./DocumentReceivingSettings.vue?vue&type=script&lang=js"
export * from "./DocumentReceivingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports